import { getCookie } from '@/utils/cookie'
import Url from '@mc/mc-utils/js/url/url'
import { miniProgramEnv } from '@/defines/environment'

const getFromUrl = () => {
  const url = new Url(window.location.href)
  const { location } = url.parseQuerystring()
  return location
}

export const getBCLocation = userInfo => {
  if (userInfo.location) {
    return userInfo.location
  } else if (miniProgramEnv.isMiniProgram) {
    return getFromUrl()
  } else {
    getCookie('mc_front_location')
  }
}
